import { AdditionalServicesService } from '@additional-services/services/additional-services.service';
import { GaEventService } from '@analytics/services/ga.event.service';
import { LocationStrategy } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import { BaseComponent } from '@core/components/base/base.component';
import { fadeInOut } from '@dgx-pr-spa/shared/util';
import { ProductDetailsService } from '@product-details/services/product-details.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.container.html',
  styleUrls: ['./order-confirmation.container.scss'],
  animations: [fadeInOut],
})
export class OrderConfirmationContainerComponent
  extends BaseComponent
  implements OnInit
{
  constructor(
    public readonly viewOffersService: ViewOffersService,
    public readonly additionalServicesService: AdditionalServicesService,
    public readonly completeOrderService: CompleteOrderService,
    public readonly productDetailsService: ProductDetailsService,
    public readonly gaEventService: GaEventService,
    private location: LocationStrategy
  ) {
    super();
  }
  order$ = this.completeOrderService.createOrder$;
  offers$ = this.viewOffersService.offers$;
  optimizely$ = this.viewOffersService.optimizely$;
  upfront$ = this.completeOrderService.upfrontPayment$;
  selected$ = this.productDetailsService.selected$;
  formData$ = this.completeOrderService.formData$;
  cardPaymentRedirect$ = this.completeOrderService.cardPaymentRedirect$;
  itemOffer$ = this.additionalServicesService.itemOffer$;
  costSummary$ = this.completeOrderService.costSummary$;

  ngOnInit() {
    this.getOffer();
    this.setHistorytoCurrentUrl();
    this.location.onPopState(() => this.setHistorytoCurrentUrl());
  }

  /**
   * Refresh offers after complete order
   */
  getOffer() {
    this.viewOffersService.offerReference$
      .pipe(takeUntil(this.destroy$))
      .subscribe((PRRef) => {
        this.viewOffersService.loadOffers(PRRef);
        this.gaEventService.ConfirmationPageLoad();
      });
  }

  /**
   * Ensure's most recent browser history state is always set to current URL
   * This prevents navigation back to previously completed pages in PR flow
   */
  setHistorytoCurrentUrl() {
    history.pushState(null, '', window.location.href);
  }
}
